/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useRef, useState } from "react";
import "./CompanyProfile.css";
import { Row, Col, Rate, Input, Carousel, Empty, Button, Modal } from "antd";
import { CameraOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import facebookicon from "../../assets/img/facebookicon.png";
import Googleicon from "../../assets/img/Googleicon.png";
import cameraicon from "../../assets/icons/camera.png";
import editicon from "../../assets/img/editicon.png";
import deleteicon from "../../assets/img/deleteicon.png";
import threedots from "../../assets/img/threedots.png";
import appleicon from "../../assets/img/appleicon.png";
import linkedinicon from "../../assets/img/linkedinicon.png";
import personicon from "../../assets/img/personicon.png";
import dollaricon from "../../assets/img/dollaricon.png";
import calendaricon from "../../assets/img/calendaricon.png";
import suitcaseicon from "../../assets/img/suitcaseicon.png";
import moment from "moment";
import JobCard from "../../components/JobCard/JobCard";
import candidate_img from "../../assets/img/becomeACandidate.png";
import Loader from "../../components/Loading/Loader";
import { useDispatch, useSelector } from "react-redux";
import history from "../../routes/history";
import MediaQuery from "react-responsive";
import { Card } from "antd";
import {
  fetchUserProfile,
  getCompanyGigs,
  getCompanyProfileDetails,
  updateCompanyProfileLinkedAccounts,
} from "../../redux/actions";
import { getImage } from "../../utilities/storageOperations/downloadURL";
import { getImageByStateCode } from "./components/cloudinary";
import { DefaultRating } from "../../assets/helpers";

export default function CompanyProfile() {
  const dispatch = useDispatch();
  const [marquePicUrl, setmarquePicUrl] = useState("");
  const [profilePictureUrl, setprofilePictureUrl] = useState("");
  const [culturePicturesUrl, setculturePicturesUrl] = useState([]);
  const [ourpeoplePictureUrl, setourpeoplePictureUrl] = useState("");
  const [Dimensions, setDimensions] = useState(getWindowDimensions());
  const [linkedAccounts, setLinkedAccounts] = useState();
  const [addLinkedAccountValue, setAddLinkedAccountValue] = useState("");
  const [inputValue, setInputvalue] = useState("");
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [linkKey, setLinkKey] = useState("");
  const [errorUrl, setErrorUrl] = useState(false);
  const [bannerErrorCheck, setBannerErrorCheck] = useState(false);

  const profileDetails = useSelector(
    (state) => state.profileReducer.user.profile
  );

  const resp = useSelector(
    (state) => state.getCompanyProfileDetailsReducer.resp
  );

  const cGigs = useSelector((state) => state.getCompanyGigsReducer.gigs);

  const cGigsCount = useSelector(
    (state) => state.getCompanyGigsReducer.gigsCount
  );

  const token = useSelector((state) => state.authReducer.user.authToken);

  const loading = useSelector(
    (state) => state.getCompanyProfileDetailsReducer.loading
  );

  const gigsLoading = useSelector(
    (state) => state.getCompanyGigsReducer.loading
  );
  const error = useSelector(
    (state) => state.getCompanyProfileDetailsReducer.error
  );
  const description = resp?.companyProfile?.CompanyDescription;
  const professionCode = useSelector(
    (state) => state.profileReducer.user.profile?.ProfessionCode
  );

  const success_ = useSelector(
    (state) => state.getCompanyDetailsReducer.success
  );

  const response_ = useSelector(
    (state) => state.getCompanyDetailsReducer.details
  );

  // useEffect(() => {
  //   if (profileDetails) {
  //     let linkedAccounts = {
  //       Facebook: profileDetails.Facebook,
  //       Google: profileDetails.Google,
  //       Apple: profileDetails.Apple,
  //       LinkedIn: profileDetails.LinkedIn,
  //     }

  //     setLinkedAccounts(linkedAccounts)
  //   }
  // }, [profileDetails]);

  useEffect(() => {
    let linkedAccounts = {
      Facebook: resp?.companyProfile?.Facebook,
      Google: resp?.companyProfile?.Google,
      Apple: resp?.companyProfile?.Apple,
      LinkedIn: resp?.companyProfile?.LinkedIn,
    };

    setLinkedAccounts(linkedAccounts);
  }, [resp]);

  useEffect(() => {
    dispatch(getCompanyProfileDetails());
    dispatch(getCompanyGigs());
  }, []);

  useEffect(() => {
    if (resp?.length !== 0) {
      getMarquePicture();
      getProfilePicture();
      getCulturePictures();
      getOutPeoplePicture();
    }
  }, [resp]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getMarquePicture = () => {
    var url = `${process.env.REACT_APP_S3_URL}/content/pics/albums/thumbs/${resp.companyProfile.MarqueePictureId}`;
    if (url !== null) {
      setmarquePicUrl(url);
      // getImage(url)
      //   .then((result) => {
      //     console.log("marquePicUrl>result:", result);
      //     setmarquePicUrl(result);
      //   })
      //   .catch(() => {
      //     console.log("Error in loading image");
      //   });
    } else {
      // console.log("empty");
    }
  };
  const getProfilePicture = () => {
    var url = resp.companyProfile.PictureUrl;
    if (url !== null) {
      setprofilePictureUrl(url);
      // getImage(url)
      //   .then((result) => {
      //     console.log("ProfilePictureURL result>>>>", result);
      //   })
      //   .catch(() => {
      //     console.log("Error in loading image");
      //   });
    }
    // else {
    //   console.log("empty");
    // }
  };

  const getCulturePictures = async () => {
    var culturePictures = [];
    if (
      resp.companyCulturePhotos?.length > 0 &&
      resp.companyCulturePhotos[0].Album_Pictures.length > 0
    ) {
      for (
        let i = 0;
        i < resp.companyCulturePhotos[0].Album_Pictures.length;
        i++
      ) {
        var url = `content/pics/albums/thumbs/${resp.companyCulturePhotos[0].Album_Pictures[i].Filename}`;
        if (url !== null) {
          // const result = await getImage(url);
          culturePictures.push(url);
        }
        // else {
        //   console.log("culturePictures with URL empty");
        // }
      }
      setculturePicturesUrl(culturePictures);
    }
  };

  const getOutPeoplePicture = () => {
    if (
      resp.ourPeoplePhotos?.length > 0 &&
      resp.ourPeoplePhotos[0].Album_Pictures.length > 0
    ) {
      var url = resp.ourPeoplePhotos[0].Album_Pictures[0].Filename;
      if (url !== null) {
        setourpeoplePictureUrl(url);
        // getImage(url)
        //   .then((result) => {
        //   })
        //   .catch(() => {
        //     console.log("Error in loading image");
        //   });
      }
      // else {
      //   console.log("empty");
      // }
    }
  };
  const imageURLSplit = (url) => {
    var key = url.split("/");
    return key[2];
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = (key) => {
    // console.log("mujjjj ", key, linkedAccounts);
    setLinkKey(key);
    setIsModalVisible(true);
    // setInputvalue(" ");
    if (key == "facebook") {
      if (
        linkedAccounts?.Facebook == null ||
        linkedAccounts?.Facebook == undefined
      ) {
        setInputvalue("");
        setAddLinkedAccountValue("");
      } else {
        setAddLinkedAccountValue(linkedAccounts.Facebook);

        setInputvalue(linkedAccounts.Facebook);
      }
    } else if (key == "google") {
      if (
        linkedAccounts?.Google == null ||
        linkedAccounts?.Google == undefined
      ) {
        setInputvalue("");
        setAddLinkedAccountValue("");
      } else {
        setAddLinkedAccountValue(linkedAccounts.Google);
        setInputvalue(linkedAccounts.Google);
      }
    } else if (key == "apple") {
      if (linkedAccounts?.Apple == null || linkedAccounts?.Apple == undefined) {
        setInputvalue("");
        setAddLinkedAccountValue("");
      } else {
        setInputvalue(linkedAccounts.Apple);
        setAddLinkedAccountValue(linkedAccounts.Apple);
      }
    } else if (key == "linkedIn") {
      if (
        linkedAccounts?.LinkedIn == null ||
        linkedAccounts?.LinkedIn == undefined
      ) {
        setInputvalue("");
        setAddLinkedAccountValue("");
      } else {
        setInputvalue(linkedAccounts.LinkedIn);
        setAddLinkedAccountValue(linkedAccounts.LinkedIn);
      }
    }
  };

  const handleOk = () => {
    // console.log("Linked Accounts>>link key", linkKey, URL);
    // console.log(
    //   "Linked Accounts>>addLinkedAccountValue",
    //   addLinkedAccountValue
    // );
    let temp;
    if (URL == false || inputValue?.length == 0 || inputValue == "") {
      setErrorUrl(true);
    } else {
      if (linkKey == "facebook" && URL == true) {
        setLinkedAccounts({
          ...linkedAccounts,
          Facebook: addLinkedAccountValue,
        });
        temp = { ...linkedAccounts, Facebook: addLinkedAccountValue };
      } else if (linkKey == "google") {
        setLinkedAccounts({ ...linkedAccounts, Google: addLinkedAccountValue });
        temp = { ...linkedAccounts, Google: addLinkedAccountValue };
      } else if (linkKey == "apple") {
        setLinkedAccounts({ ...linkedAccounts, Apple: addLinkedAccountValue });
        temp = { ...linkedAccounts, Apple: addLinkedAccountValue };
      } else if (linkKey == "linkedIn") {
        setLinkedAccounts({
          ...linkedAccounts,
          LinkedIn: addLinkedAccountValue,
        });
        temp = { ...linkedAccounts, LinkedIn: addLinkedAccountValue };
      }
      setErrorUrl(false);
      dispatch(updateCompanyProfileLinkedAccounts(temp));
      setIsModalVisible(false);
    }

    // console.log("bilal ", temp);
    //dispatch(updateCompanyProfileDetails(linkedAccounts));
  };

  // useEffect(() => {
  //   // dispatch(updateCompanyProfileLinkedAccounts(linkedAccounts));
  //   // console.log(("Linked Accounts>>", linkedAccounts));
  // }, [linkedAccounts]);

  const [URL, setURL] = useState("");

  const urlPatternValidation = (URL) => {
    // const regex = new RegExp(
    //   // "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
    //   // "^(?:https?|ftp)://[^\s/$.?#].[^\s]*$"
    //   // "\b(?:https?://|www\.)\S+\b"
    //   // "^(https?|ftp):\/\/(([a-z0-9]+([-_][a-z0-9]+)*\.)+[a-z]{2,}|(localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}))(:\d+)?(\/([^\s\/?#]+\/)*([^\s\/?#]+\.[^\s\/?#]+)?(\?[^#\s]*)?(#.*)?)?$"
    //   // "/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/"
    // );
    // return regex.test(URL);
    return /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/.test(
      URL
    );
  };

  // Function to go to the next slide
  const nextSlide = () => {
    carouselRef.current.next();
  };

  // Function to go to the previous slide
  const prevSlide = () => {
    carouselRef.current.prev();
  };

  // Calculate the number of slides based on the number of images and items per slide
  const itemsPerSlide = Dimensions.width > 768 ? 3 : 1; // Change this as needed
  const totalSlides = Math.ceil(culturePicturesUrl.length / itemsPerSlide);

  // Divide the images into groups for each slide
  const slides = [];
  for (let i = 0; i < totalSlides; i++) {
    const startIdx = i * itemsPerSlide;
    const endIdx = startIdx + itemsPerSlide;
    slides.push(culturePicturesUrl.slice(startIdx, endIdx));
  }
  const carouselRef = useRef(null);

  const changeUrl = (e) => {
    setInputvalue(e);
    const value = e;
    const validationCheck = urlPatternValidation(value);
    // console.log("AddURLValidationCheck>> regex:::",validationCheck);
    // console.log("AddURLValidationCheck>> value length:::",value.length>0);
    const isTrueVal = value.length > 0 && validationCheck;
    setURL(isTrueVal);

    // console.log('AddURLValidationCheck>>',isTrueVal);
    isTrueVal == true
      ? setAddLinkedAccountValue(value)
      : setAddLinkedAccountValue("");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setInputvalue("");
    setErrorUrl(false);
  };

  const deleteLink = (key) => {
    // console.log("Linked Accounts>>delete:", key);
    let temp;
    if (key == "facebook") {
      setLinkedAccounts({ ...linkedAccounts, Facebook: null });
      temp = { ...linkedAccounts, Facebook: null };
    } else if (key == "google") {
      setLinkedAccounts({ ...linkedAccounts, Google: null });
      temp = { ...linkedAccounts, Google: null };
    } else if (key == "apple") {
      setLinkedAccounts({ ...linkedAccounts, Apple: null });
      temp = { ...linkedAccounts, Apple: null };
    } else if (key == "linkedIn") {
      setLinkedAccounts({ ...linkedAccounts, LinkedIn: null });
      temp = { ...linkedAccounts, LinkedIn: null };
    }

    dispatch(updateCompanyProfileLinkedAccounts(temp));
  };

  //********** convert encrypted html code to HTML tags **********
  var cache = {},
    character,
    e = document.createElement("div");

  const msgtxt = (html) => {
    return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
      character = cache[entity];
      if (!character) {
        e.innerHTML = entity;
        if (e.childNodes[0])
          character = cache[entity] = e.childNodes[0].nodeValue;
        else character = "";
      }
      return character;
    });
  };
  //*********************************************//

  // console.log('loading gig',gigsLoading);
  // console.log('loading cp',loading);

  if (!gigsLoading && !loading && resp.length !== 0) {
    return (
      <div className="home-container home-container-mobile-view">
        <Modal
          className="add-modal"
          title="Add link"
          visible={isModalVisible}
          // onOk={URL ? handleOk : true}
          cancelButtonProps={{ style: { display: "none" } }}
          onCancel={handleCancel}
          // okText="Save"
          footer={[
            <Button type="primary" loading={loading} onClick={handleOk}>
              Save
            </Button>,
          ]}
        >
          <Input
            placeholder={inputValue ? null : "Add a link to your account..."}
            onChange={(e) => {
              changeUrl(e.target.value);
            }}
            value={inputValue}
          />
          {errorUrl && (
            <span style={{ color: "red", fontSize: "0.85rem" }}>
              Please enter valid URL
            </span>
          )}
        </Modal>

        <Col xs={22} sm={24} md={24} lg={24}>
          <Row>
            <Col span={Dimensions.width > 768 ? 24 : 8}>
              {Dimensions.width > 768 && (
                <div
                  className="bannerdiv"
                  style={{
                    marginTop: Dimensions.width > 768 ? "-10px" : "0px",
                  }}
                >
                  {resp?.length !== 0 ? (
                    !bannerErrorCheck &&
                    resp.companyProfile.MarqueePictureId !== null &&
                    marquePicUrl !== "" ? (
                      <div
                        style={{
                          // position: "absolute",
                          width: "100%",
                          height: "320px",
                        }}
                      >
                        <img
                          src={`${marquePicUrl}`}
                          // src={`${process.env.REACT_APP_S3_URL}${marquePicUrl?.charAt(0) !== "/" ? '/' : ""}${marquePicUrl}`}
                          alt="Marque Picture"
                          className="_img MarquePic"
                          style={{
                            zIndex: "-1",
                          }}
                          onError={(err) => {
                            // console.log('Marquee banner image err',err)
                            setBannerErrorCheck(true);
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            // width: "120%",
                            marginTop: "-180px",
                            // marginTop: "80px",
                            // marginTop: "80px",
                            justifyContent: "end",
                            alignItems: "end",
                            // position: 'absolute',
                            zIndex: 5,
                            right: "0%",
                          }}
                        >
                          <button
                            className="bannerbtn2"
                            style={{ marginTop: "6rem" }}
                            onClick={() => {
                              history.push("/marqueealbum");
                              dispatch(fetchUserProfile(token));
                            }}
                          >
                            Edit banner
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "grid",
                          height: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: "-1",
                        }}
                      >
                        <div className="circle-backg"></div>
                        <CameraOutlined
                          style={{ fontSize: "40px", gridArea: "1/1" }}
                          onClick={() => history.push("/marqueealbum")}
                        />
                        {/* <button
                          className="uploadbtn bannerbtn "
                          onClick={() => history.push("/marqueealbum")}
                        >
                          + Upload Banner
                        </button> */}
                      </div>
                    )
                  ) : null}
                </div>
              )}

              <div className="prof-circle">
                {resp?.length !== 0 ? (
                  resp.companyProfile.PictureUrl !== null ? (
                    <img
                      // src={profilePictureUrl}
                      src={`${process.env.REACT_APP_S3_URL}${
                        profilePictureUrl?.charAt(0) !== "/" ? "/" : ""
                      }${profilePictureUrl}`}
                      style={
                        {
                          // height: "auto",
                          // objectPosition: '50% 50%',
                        }
                      }
                      className={
                        Dimensions.width > 768
                          ? "profile_img"
                          : "profile_img-small"
                      }
                    />
                  ) : (
                    <h1
                      style={{
                        color: "white",
                        display: "flex",
                        margin: "auto",
                      }}
                    >
                      {resp?.companyProfile?.CompanyName?.split(
                        ""
                      )[0].toUpperCase()}
                    </h1>
                  )
                ) : null}
              </div>
              <img
                src={profilePictureUrl ? editicon : cameraicon}
                alt="editicon"
                className="editIcon-sm profile-edit"
                style={{
                  position: Dimensions.width > 768 && "absolute",
                  marginTop: Dimensions.width > 768 && "30px",
                  marginLeft: Dimensions.width > 768 && "145px",
                  zIndex: Dimensions.width > 768 && "2",
                }}
                onClick={() => {
                  history.push({
                    pathname: "/CompanyLogo",
                    state: {
                      Key: resp.companyProfile.PictureUrl,
                    },
                  });
                }}
              />
            </Col>
            <Col span={16}>
              {Dimensions.width < 769 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    justifyContent: "center",
                  }}
                >
                  <div className="comp-head">
                    {resp.companyProfile.CompanyName !== null
                      ? resp.companyProfile.CompanyName
                      : "Company Name"}
                  </div>
                  <div className="head-sub">
                    {resp.companyProfile?.LocationWithCountry &&
                    resp.companyProfile?.LocationWithCountry
                      ? resp.companyProfile?.LocationWithCountry
                      : "Location"}
                  </div>
                  <Row
                    style={{
                      width: "60%",
                      display: "flex",
                      // justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Rate
                        className="comp-rate-cp"
                        disabled
                        allowHalf
                        value={
                          resp?.companyProfile?.Rating
                            ? resp?.companyProfile?.Rating
                            : DefaultRating
                        }
                        defaultValue={DefaultRating}
                      ></Rate>
                    </div>
                    <div className="comp-rating">
                      {resp?.companyProfile?.Rating
                        ? resp?.companyProfile?.Rating
                        : DefaultRating}
                    </div>
                    <div className="comp-rating comp-sub">
                      (
                      {resp?.companyProfile?.Review
                        ? resp?.companyProfile?.Review
                        : 0}
                      )
                    </div>
                  </Row>
                </div>
              )}
              {Dimensions.width > 768 && (
                <div className="comp-head">
                  <div className="comp-head-name">
                    {resp.companyProfile.CompanyName !== null
                      ? resp.companyProfile.CompanyName
                      : "Company Name"}
                  </div>
                  <div className="head-location">
                    {resp.companyProfile.LocationWithCounty != null
                      ? resp.companyProfile?.LocationWithCounty
                      : resp.companyProfile?.LocationWithCountry != null
                      ? resp.companyProfile?.LocationWithCountry
                      : "Location"}
                  </div>
                  <div style={{ paddingBottom: "20px" }}>
                    <div className="head-rating">
                      <Rate
                        className="comp-rate-cp"
                        disabled
                        allowHalf
                        defaultValue={
                          resp?.companyProfile?.Rating
                            ? parseFloat(resp?.companyProfile?.Rating)
                            : DefaultRating
                        }
                      ></Rate>
                    </div>
                    <div className="comp-rating">
                      <span className="comp-rating comp-review">
                        {resp?.companyProfile?.Rating
                          ? resp?.companyProfile?.Rating
                          : DefaultRating}
                      </span>
                      {(resp?.companyProfile?.Review &&
                        resp?.companyProfile?.Review) > 0 && (
                        <span className="comp-rating comp-sub">
                          (
                          {resp?.companyProfile?.Review
                            ? resp?.companyProfile?.Review
                            : 0}{" "}
                          {resp?.companyProfile?.Review == 1
                            ? "review"
                            : "reviews"}
                          )
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="head-data">
                    <Row>
                      <Col span={8}>
                        <div
                          // style={{ cursor: resp.jobs !== 0 && "pointer" }}
                          // style={{ cursor: cGigsCount&& cGigsCount !== 0 && "pointer" }}
                          // style={{ cursor: cGigsCount&& cGigsCount !== 0 && "default" }}
                          style={{
                            cursor: cGigsCount > 0 ? "pointer" : "default",
                          }}
                          className="head-data-item"
                          onClick={() =>
                            history.push({
                              pathname: "/joblisting",
                              state: { param: resp?.jobs },
                            })
                          }
                        >
                          <div className="head-data-item-number">
                            {cGigsCount ? cGigsCount : 0}
                          </div>
                          <div className="head-data-item-name">Gigs</div>
                        </div>
                      </Col>
                      <Col span={8}>
                        <div
                          className="head-data-item"
                          style={{ cursor: resp?.followers > 0 && "pointer" }}
                        >
                          <div className="head-data-item-number">
                            {resp.length === 0
                              ? "0"
                              : resp?.followers > 0
                              ? resp.followers
                              : 0}
                          </div>
                          <div className="head-data-item-name">Followers</div>
                        </div>
                      </Col>
                      <Col span={8}>
                        <div
                          className="head-data-item"
                          style={{ cursor: resp?.views > 0 && "pointer" }}
                          // style={{ cursor: resp?.views !== 0 && "default" }}
                          // onClick={() => {
                          //   resp?.views !== 0 && history.push("/views");
                          // }}
                        >
                          <div className="head-data-item-number">
                            {resp?.length === 0 ? "0" : resp.views}
                          </div>
                          <div className="head-data-item-name">Views</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              )}
            </Col>
          </Row>

          {Dimensions.width < 769 && (
            <>
              <div className="profileDivider"></div>
              <Row>
                {/* <Col span={8} style={{ cursor: resp.jobs !== 0 && "pointer" }}> */}
                <Col
                  span={8}
                  style={{ cursor: cGigsCount !== 0 && "pointer" }}
                  onClick={() =>
                    history.push({
                      pathname: "/joblisting",
                      state: { param: resp?.jobs },
                    })
                  }
                >
                  <Row className="following-detail-num">
                    {/* {resp.length === 0 ? "0" : resp.jobs} */}
                    {cGigsCount === 0 ? "0" : cGigsCount}
                  </Row>
                  <Row className="following-detail-txt">Gigs</Row>
                </Col>
                <Col span={8}>
                  <Row className="following-detail-num">
                    {/* {resp.length === 0 ? "0" : resp.followers} */}
                    {resp?.companyProfile?.followers?.length > 0
                      ? resp?.companyProfile?.followers?.length
                      : 0}
                  </Row>
                  <Row
                    className="following-detail-txt"
                    onClick={() => {
                      // resp?.followers !== 0 && history.push("/followers");
                      // console.log('going to followers');
                      resp?.companyProfile?.followers?.length > 0 &&
                        history.push("/followers");
                    }}
                  >
                    {" "}
                    Followers
                  </Row>
                </Col>
                <Col span={8}>
                  <Row className="following-detail-num">
                    {resp.length === 0 ? "0" : resp.views}
                  </Row>
                  <Row
                    className="following-detail-txt"
                    onClick={() => {
                      resp?.views !== 0 && history.push("/views");
                    }}
                  >
                    Views
                  </Row>
                </Col>
              </Row>
            </>
          )}

          {Dimensions.width < 769 && <div className="profileDivider"></div>}
          <div className="comp-second-container">
            {Dimensions.width > 768 && (
              <div className="company-details-container">
                <Row className="row-container">
                  <Col className="company-detail-heading add-left-column-margin">
                    Company details
                  </Col>
                  <Col
                    className="company-edit-heading"
                    onClick={() => {
                      history.push({
                        pathname: "/companyprofile/companydetails",
                        state: {
                          // ProfileImageURL: profilePictureUrl,
                          // ProfileImageURL: JSON.parse(localStorage.getItem("profilePicture")),
                          CompanyName: resp.companyProfile?.CompanyName,
                          CompanyType: resp.companyProfile?.CompanyType,
                          CompanySize: resp.companyProfile?.CompanySize,
                          IndustryName:
                            resp.companyProfile?.Industries?.IndustryName,
                          YearFounded: resp.companyProfile?.YearFounded,
                          previous: "companyprofile",
                        },
                      });
                    }}
                  >
                    Edit
                  </Col>
                </Row>
                <div className="profileDivider"></div>
                <Row className="row-container">
                  <Col className="left-column">Company type</Col>
                  <Col className="right-column">
                    {resp.companyProfile?.CompanyType !== null
                      ? resp.companyProfile?.CompanyType
                      : "N/A"}
                  </Col>
                </Row>

                <Row className="row-container">
                  <Col className="left-column">Company size</Col>
                  <Col className="right-column">
                    {resp.companyProfile?.CompanySize !== null
                      ? resp.companyProfile?.CompanySize
                      : "N/A"}
                  </Col>
                </Row>

                <Row className="row-container">
                  <Col className="left-column">Industry</Col>
                  <Col className="right-column">
                    {resp.companyProfile?.Industries?.IndustryName !== null
                      ? resp.companyProfile?.Industries?.IndustryName
                      : "N/A"}
                  </Col>
                </Row>

                <Row className="row-container">
                  <Col className="left-column">Location</Col>
                  <Col className="right-column">
                    {" "}
                    {
                      // resp.length === 0
                      resp.companyProfile.Location &&
                      resp.companyProfile.Location.Location
                        ? resp.companyProfile.Location.Location
                        : "N/A"
                    }
                  </Col>
                </Row>

                <Row className="row-container">
                  <Col className="left-column">Year founded</Col>
                  <Col className="right-column">
                    {resp.companyProfile.YearFounded !== null
                      ? resp.companyProfile.YearFounded
                      : "N/A"}
                  </Col>
                </Row>
              </div>
            )}

            <div className="linked-Accdiv">
              <div className="linked-head"> Linked social accounts</div>
              <div className="profileDivider2"></div>
              <div className="social-container">
                <Row style={{ height: "80%" }}>
                  <Col
                    span={18}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-evenly",
                    }}
                  >
                    {linkedAccounts?.Facebook != null ||
                    linkedAccounts?.Facebook != undefined ? (
                      <Row className="linked-account-det">
                        <Col span={3} className="linked-account-det-icon">
                          <img
                            src={facebookicon}
                            alt="facebookicon"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </Col>
                        <Col
                          onClick={() =>
                            window.open(
                              linkedAccounts?.Facebook,
                              "_blank",
                              "noreferrer"
                            )
                          }
                          style={{ cursor: "pointer" }}
                          className="linked-details"
                        >
                          Facebook
                        </Col>
                      </Row>
                    ) : null}

                    {/* {linkedAccounts?.Google != null ||
                    linkedAccounts?.Google != undefined ? (
                    <Row className="linked-account-det">
                      <Col span={3} className="linked-account-det-icon">
                        <img
                          src={Googleicon}
                          alt="googleicon"
                          style={{ width: "20px", height: "20px" }}
                        />
                      </Col>
                      <Col onClick={()=>window.open(linkedAccounts?.Google, '_blank', 'noreferrer')} className="linked-details">Google</Col>
                    </Row>
                  ) : null} */}

                    {/* {linkedAccounts?.Apple != null ||
                    linkedAccounts?.Apple != undefined ? (
                    <Row className="linked-account-det">
                      <Col span={3} className="linked-account-det-icon">
                        <img
                          src={appleicon}
                          alt="appleicon"
                          style={{ width: "20px", height: "20px" }}
                        />
                      </Col>
                      <Col onClick={()=>window.open(linkedAccounts?.Apple, '_blank', 'noreferrer')} className="linked-details">
                        <div>Apple</div>
                      </Col>
                    </Row>
                  ) : null} */}

                    {linkedAccounts?.LinkedIn != null ||
                    linkedAccounts?.LinkedIn != undefined ? (
                      <Row className="linked-account-det mob-view-space">
                        <Col span={3} className="linked-account-det-icon">
                          <img
                            src={linkedinicon}
                            alt="linkedinicon"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </Col>
                        <Col
                          onClick={() =>
                            window.open(
                              linkedAccounts?.LinkedIn,
                              "_blank",
                              "noreferrer"
                            )
                          }
                          className="linked-details"
                        >
                          <div>LinkedIn</div>
                        </Col>
                      </Row>
                    ) : null}
                  </Col>

                  <Col
                    span={6}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-evenly",
                    }}
                  >
                    {linkedAccounts?.Facebook != null ||
                    linkedAccounts?.Facebook != undefined ? (
                      <Row className="iconsComtainer">
                        <Col
                          style={{ "margin-right": "5px" }}
                          className="linked-icons"
                        >
                          <img
                            src={editicon}
                            alt="editicon"
                            className="editIcon-sm"
                            onClick={() => {
                              showModal("facebook");
                              setURL(
                                new RegExp(
                                  "^(?:https?|ftp)://[^s/$.?#].[^s]*$"
                                ).test(linkedAccounts.Facebook)
                              );
                            }}
                          />
                        </Col>
                        <Col className="deleteIcon-cont">
                          <img
                            src={deleteicon}
                            alt="deleteicon"
                            className="deleteIcon-sm"
                            onClick={() => deleteLink("facebook")}
                          />
                        </Col>
                      </Row>
                    ) : null}

                    {/* {linkedAccounts?.Google != null ||
                    linkedAccounts?.Google != undefined ? (
                    <Row className="iconsComtainer">
                      <Col className="linked-icons" style={{ 'margin-right': '5px' }}>
                        <img
                          src={editicon}
                          alt="editicon"
                          className="editIcon-sm"
                          onClick={() => {
                            showModal("google");
                            setURL(new RegExp("^(?:https?|ftp)://[^\s/$.?#].[^\s]*$").test(linkedAccounts.Google));
                          }}
                        />
                      </Col>
                      <Col className="deleteIcon-cont">
                        <img
                          src={deleteicon}
                          alt="deleteicon"
                          className="deleteIcon-sm"
                          onClick={() => deleteLink("google")}
                        />
                      </Col>
                    </Row>
                  ) : null} */}

                    {/* {linkedAccounts?.Apple != null ||
                    linkedAccounts?.Apple != undefined ? (
                    <Row className="iconsComtainer">
                      <Col className="linked-icons" style={{ 'margin-right': '5px' }}>
                        <img
                          src={editicon}
                          alt="editicon"
                          className="editIcon-sm"
                          onClick={() => {
                            showModal("apple");
                            setURL(new RegExp("^(?:https?|ftp)://[^\s/$.?#].[^\s]*$").test(linkedAccounts.Apple));
                          }}
                        />
                      </Col>
                      <Col className="deleteIcon-cont">
                        <img
                          src={deleteicon}
                          alt="deleteicon"
                          className="deleteIcon-sm"
                          onClick={() => deleteLink("apple")}
                        />
                      </Col>
                    </Row>
                  ) : null} */}

                    {linkedAccounts?.LinkedIn != null ||
                    linkedAccounts?.LinkedIn != undefined ? (
                      <Row className="iconsComtainer">
                        <Col
                          className="linked-icons"
                          style={{ "margin-right": "5px" }}
                        >
                          <img
                            src={editicon}
                            alt="editicon"
                            className="editIcon-sm"
                            onClick={() => {
                              showModal("linkedIn");
                              setURL(
                                new RegExp(
                                  "^(?:https?|ftp)://[^s/$.?#].[^s]*$"
                                ).test(linkedAccounts.LinkedIn)
                              );
                            }}
                          />
                        </Col>
                        <Col className="deleteIcon-cont">
                          <img
                            src={deleteicon}
                            alt="deleteicon"
                            className="deleteIcon-sm"
                            onClick={() => deleteLink("linkedIn")}
                          />
                        </Col>
                      </Row>
                    ) : null}
                  </Col>

                  {linkedAccounts?.Facebook == null ||
                  linkedAccounts?.Facebook == undefined ? (
                    <Col
                      span={18}
                      className="linked-details-col"
                      onClick={() => showModal("facebook")}
                    >
                      <Row className="linked-account-det">
                        <Col className="linked-details-add-icon">+</Col>
                        <Col className="linked-details-add">Facebook</Col>
                      </Row>
                    </Col>
                  ) : null}

                  {/* {linkedAccounts?.Google == null ||
                  linkedAccounts?.Google == undefined ? (
                  <Col
                    span={18}
                    className="linked-details-col"
                    onClick={() => showModal("google")}
                  >
                    <Row className="linked-account-det">
                      <Col className="linked-details-add-icon">+</Col>
                      <Col className="linked-details-add">Google</Col>
                    </Row>
                  </Col>
                ) : null} */}

                  {/* {linkedAccounts?.Apple == null ||
                  linkedAccounts?.Apple == undefined ? (
                  <Col
                    span={18}
                    className="linked-details-col"
                    onClick={() => showModal("apple")}
                  >
                    <Row className="linked-account-det">
                      <Col className="linked-details-add-icon">+</Col>
                      <Col className="linked-details-add">Apple</Col>
                    </Row>
                  </Col>
                ) : null} */}

                  {linkedAccounts?.LinkedIn == null ||
                  linkedAccounts?.LinkedIn == undefined ? (
                    <Col
                      span={18}
                      className="linked-details-col"
                      onClick={() => showModal("linkedIn")}
                    >
                      <Row className="linked-account-det">
                        <Col className="linked-details-add-icon">+</Col>
                        <Col className="linked-details-add">LinkedIn</Col>
                      </Row>
                    </Col>
                  ) : null}
                </Row>
              </div>
            </div>
          </div>
          {Dimensions.width < 769 && (
            <div className="bannerdiv">
              {/* {resp?.length !== 0 ? (
                // resp?.companyProfile?.Albums[0]?.AlbumTypes?.AlbumTypeCode !== null && marquePicUrl !== "" ? (
                marquePicUrl !== "" ? ( */}
              {resp?.length !== 0 ? (
                !bannerErrorCheck &&
                resp.companyProfile.MarqueePictureId !== null &&
                marquePicUrl !== "" ? (
                  <div style={{ width: "100%", height: "100%" }}>
                    <img
                      src={marquePicUrl}
                      alt="Marque Picture"
                      className="_img MarquePic"
                      style={{ objectFit: "fill" }}
                      onError={() => {
                        setBannerErrorCheck(true);
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        width: "95%",
                        marginTop: "-7rem",
                        justifyContent: "end",
                        alignItems: "end",
                      }}
                    >
                      <button
                        className="bannerbtn2 "
                        onClick={() => {
                          history.push("/marqueealbum");
                          dispatch(fetchUserProfile(token));
                        }}
                      >
                        Edit banner
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      height: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      className="uploadbtn bannerbtn "
                      onClick={() => history.push("/marqueealbum")}
                    >
                      + Upload banner
                    </button>
                  </div>
                )
              ) : null}
            </div>
          )}
          {Dimensions.width < 769 && (
            <>
              <div>
                <Row style={{ marginTop: "7%" }}>
                  <Col className="company-details-outter-div" span={12}>
                    <div className="comp-heading1">Company details</div>
                    <div className="profileDivider2"></div>
                    <div className="compdetails-div1">
                      <div>Company type</div>
                      <div>Company size</div>
                      <div>Industry</div>
                      <div>Location</div>
                      <div>Year founded</div>
                    </div>
                  </Col>
                  <Col span={12} className="comp-main">
                    <div
                      className="comp-heading2"
                      onClick={() => {
                        history.push({
                          pathname: "/companyprofile/companydetails",
                          state: {
                            ProfileImageURL: profilePictureUrl,
                            CompanyName: resp.companyProfile.CompanyName,
                            CompanyType: resp.companyProfile.CompanyType,
                            CompanySize: resp.companyProfile.CompanySize,
                            IndustryName:
                              resp.companyProfile?.Industries?.IndustryName,
                            YearFounded: resp.companyProfile.YearFounded,
                          },
                        });
                      }}
                    >
                      Edit
                    </div>
                    <div className="compdetails-div2">
                      <div>
                        {resp.companyProfile.CompanyType !== null
                          ? resp.companyProfile.CompanyType
                          : "N/A"}
                      </div>
                      <div>
                        {resp.companyProfile.CompanySize !== null
                          ? resp.companyProfile.CompanySize
                          : "N/A"}
                      </div>
                      <div className="cpIndustryDiv">
                        {resp.companyProfile?.Industries?.IndustryName !== null
                          ? resp.companyProfile?.Industries?.IndustryName
                          : "N/A"}
                      </div>
                      <div>
                        {
                          // resp.length === 0
                          resp.companyProfile.Location &&
                          resp.companyProfile.Location.Location
                            ? resp.companyProfile.Location.Location
                            : "N/A"
                        }
                      </div>
                      <div>
                        {resp.companyProfile.YearFounded !== null
                          ? resp.companyProfile.YearFounded
                          : "N/A"}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="profileDivider"></div>
            </>
          )}
          <div className="culture-container">
            <Row>
              <Col span={12}>
                <div className="headings">Our culture</div>
              </Col>
              <Col span={12}>
                {culturePicturesUrl.length > 0 ? (
                  <div
                    className="comp-main comp-heading2"
                    onClick={() => {
                      history.push("/companyprofile/companyculturephotos");
                    }}
                  >
                    Edit
                  </div>
                ) : (
                  <div className="comp-main comp-heading3"></div>
                )}
              </Col>
            </Row>
            <div className="profileDivider3"></div>
            <div className="heading-txt">
              Highlight your company’s culture! Add pictures like your offices
              or past events.
            </div>
            {resp.companyCulturePhotos?.length > 0 &&
            resp.companyCulturePhotos[0].Album_Pictures?.length > 0 &&
            culturePicturesUrl.length > 0 ? (
              <div
                className="companyProfile-carousel"
                style={{ position: "relative" }}
              >
                {/* Left Arrow Button */}
                <Button
                  className="carousel-button"
                  type="primary"
                  shape="square"
                  icon={<BiChevronLeft style={{ fontSize: "1.8rem" }} />}
                  onClick={prevSlide}
                  style={{
                    display:
                      culturePicturesUrl.length >
                      (Dimensions.width > 768 ? 3 : 1)
                        ? ""
                        : "none",
                    position: "absolute",
                    left: "2%", // Adjust the left position as needed
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1, // Ensure it's above the Carousel,
                    color: "#fffff",
                    // height: '64px',
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    border: "none",
                  }}
                />
                <Carousel
                  autoplay
                  ref={carouselRef}
                  // arrows
                  dots
                >
                  {slides.map((slide, index) => (
                    <div key={index}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start", // Align items to the top
                          flexWrap: "wrap", // Allow items to wrap to the next line
                          marginBottom: "10px", // Add space between rows
                          paddingLeft: "2%",
                        }}
                      >
                        {slide.map((item, itemIndex) => (
                          <img
                            key={itemIndex}
                            src={`${process.env.REACT_APP_S3_URL}${
                              item?.charAt(0) !== "/" ? "/" : ""
                            }${item}`}
                            alt="Culture Picture"
                            style={{
                              width: Dimensions.width > 768 ? "32%" : "100%",
                              // height: 'auto',
                              height: "210px",
                              objectFit:
                                Dimensions.width > 768 ? "cover" : "fill",
                              marginRight:
                                Dimensions.width > 768 &&
                                itemIndex < slide.length - 1
                                  ? "10px"
                                  : "0",
                              marginBottom: "10px", // Add space between rows
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  ))}
                </Carousel>
                {/* Right Arrow Button */}
                <Button
                  className="carousel-button"
                  type="primary"
                  shape="square"
                  icon={<BiChevronRight style={{ fontSize: "1.8rem" }} />}
                  onClick={nextSlide}
                  style={{
                    display:
                      culturePicturesUrl.length >
                      (Dimensions.width > 768 ? 3 : 1)
                        ? ""
                        : "none",
                    position: "absolute",
                    // right: '2.3rem', // Adjust the right position as needed
                    right: Dimensions.width < 768 ? "0rem" : "1.65rem", // Adjust the right position as needed
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1, // Ensure it's above the Carousel
                    color: "#fffff",
                    // height: '64px',
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    border: "none",
                  }}
                />
              </div>
            ) : (
              <div className="button-container">
                <button
                  className={
                    Dimensions.width < 768
                      ? "uploadbtn photosbtn"
                      : "uploaddesbtn"
                  }
                  onClick={() =>
                    history.push("/companyprofile/companyculturephotos")
                  }
                >
                  {Dimensions.width < 768 ? `+ Add pictures` : `+`}
                </button>
                {Dimensions.width > 768 && (
                  <div className="add-heading">Add pictures</div>
                )}
              </div>
            )}
          </div>
          {Dimensions.width < 768 && <div className="profileDivider"></div>}
          <div className="whyweexist-container">
            <Row>
              <Col span={12}>
                <div className="headings">Why we exist</div>
              </Col>
              <Col span={12}>
                <div
                  className="comp-main comp-heading2"
                  onClick={() => {
                    localStorage.setItem(
                      "AboutMessage",
                      resp.companyProfile.CompanyDescription ?? ""
                    );
                    history.push({
                      pathname: "/companyprofile/aboutcompany",
                      state: {
                        CompanyDescription:
                          resp.companyProfile.CompanyDescription,
                        fromCompanyProfile: true,
                        edit:
                          resp.companyProfile.CompanyDescription?.length > 1
                            ? true
                            : false,
                      },
                    });
                  }}
                >
                  {resp.companyProfile.CompanyDescription?.length > 1
                    ? `Edit description`
                    : `Add description`}
                </div>
              </Col>
            </Row>

            <div className="profileDivider4"></div>
            <div className="heading-txt-margin"></div>
            {resp.companyProfile.CompanyDescription?.length > 1 ? (
              <div className="heading-txt heading-txt_bold">
                <div
                  dangerouslySetInnerHTML={{ __html: msgtxt(description) }}
                ></div>
                {/* <div dangerouslySetInnerHTML={{ __html: description.substring(0, 140) }}></div> */}
              </div>
            ) : (
              <div className="heading-txt heading-txt_bold">
                {/* Describe your company. Talk about your company’s mission, vision, or values. */}
                Talk about your company’s mission, vision, or values.
              </div>
            )}
          </div>
          {Dimensions.width < 768 && <div className="profileDivider"></div>}
          <div className="people-container">
  <Row>
    <Col span={12}>
      <div className="headings">Our people</div>
    </Col>
    <Col span={12}>
      {ourpeoplePictureUrl.length > 0 ? (
        <div
          className="comp-main comp-heading2"
          onClick={() => {
            history.push("/companyprofile/addemployee");
          }}
        >
          Edit
        </div>
      ) : (
        <div className="comp-main comp-heading3"></div>
      )}
    </Col>
  </Row>
  {Dimensions.width > 769 && <div className="profileDivider3"></div>}
  <div className="heading-txt">
              {/* Showcase your amazing team members! */}
    Let your happy team members sell your company for you with employee testimonials
              {/* { Dimensions.width > 769 &&
              <>
              {<br/>}
                Tell their story by adding their bio using the edit bio feature.
              </>
            } */}
  </div>
  {resp.ourPeoplePhotos?.length > 0 &&
  resp.ourPeoplePhotos[0].Album_Pictures.length > 0 &&
  resp.ourPeoplePhotos[0].Album_Pictures[0].Filename !== null ? (
    <div
      className="companyProfile-carousel"
      style={{ position: "relative" }}
    >
     
      {(() => {
        const itemsPerSlide = Dimensions.width > 768 ? 3 : 1;
        const totalSlides = Math.ceil(resp.ourPeoplePhotos[0].Album_Pictures.length / itemsPerSlide);
        const slides = [];
        
        for (let i = 0; i < totalSlides; i++) {
          const startIdx = i * itemsPerSlide;
          const endIdx = startIdx + itemsPerSlide;
          slides.push(resp.ourPeoplePhotos[0].Album_Pictures.slice(startIdx, endIdx));
        }

        return (
          <>
            
            <Button
              className="carousel-button"
              type="primary"
              shape="square"
              icon={<BiChevronLeft style={{ fontSize: "1.8rem" }} />}
              onClick={prevSlide}
              style={{
                display: resp.ourPeoplePhotos[0].Album_Pictures.length > itemsPerSlide ? "" : "none",
                position: "absolute",
                left: "2%",
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 1,
                color: "#fffff",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                border: "none",
              }}
            />
            
            <Carousel
              autoplay
              ref={carouselRef}
              dots
            >
              {slides.map((slide, slideIndex) => (
                <div key={slideIndex}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexWrap: "wrap",
                      marginBottom: "10px",
                      paddingLeft: "2%",
                    }}
                  >
                    {slide.map((item, itemIndex) => (
                      <div 
                        key={itemIndex}
                        style={{
                          width: Dimensions.width > 768 ? "32%" : "100%",
                          marginRight: Dimensions.width > 768 && itemIndex < slide.length - 1 ? "10px" : "0",
                          marginBottom: "10px",
                          display: "flex",
                          flexDirection: Dimensions.width > 768 ? "column" : "row",
                          alignItems: "center",
                        }}
                      >
                        <div style={{
                          width: Dimensions.width > 768 ? "100%" : "40%",
                          height: Dimensions.width > 768 ? "200px" : "100px",
                        }}>
                          <img
                            src={`${process.env.REACT_APP_S3_URL}/content/pics/albums/${item.Filename}`}
                            alt="people picture"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div style={{
                          width: Dimensions.width > 768 ? "100%" : "60%",
                          padding: Dimensions.width > 768 ? "10px 0" : "0 10px",
                        }}>
                          <div className="people-test">
                            {item.Name}, {item.Title}
                          </div>
                          <div className="people-test">
                            {item.WorkCulture}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </Carousel>
            <Button
              className="carousel-button"
              type="primary"
              shape="square"
              icon={<BiChevronRight style={{ fontSize: "1.8rem" }} />}
              onClick={nextSlide}
              style={{
                display: resp.ourPeoplePhotos[0].Album_Pictures.length > itemsPerSlide ? "" : "none",
                position: "absolute",
                right: Dimensions.width < 768 ? "0rem" : "1.65rem",
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 1,
                color: "#fffff",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                border: "none",
              }}
            />
          </>
        );
      })()}
    </div>
  ) : (
    <div className="button-container">
      <button
        className={
          Dimensions.width < 768
            ? "uploadbtn employeebtn"
            : "uploaddesbtn"
        }
        onClick={() => history.push("/companyprofile/empstaff")}
      >
        {Dimensions.width < 768 ? `+ Add employee` : `+`}
      </button>
      {Dimensions.width > 768 && (
        <div className="add-heading">Add employee</div>
      )}
    </div>
  )}
</div>
          {Dimensions.width < 768 && <div className="profileDivider"></div>}
          <div className="job-container">
            <Row className="jobsTileCont">
              <Col span={12}>
                <div className="job-headings">
                  Our open gigs
                  {Dimensions.width > 768 && (
                    <div className="job-length">
                      {cGigsCount ? cGigsCount : 0}
                    </div>
                  )}
                </div>
              </Col>
              <Col span={12}>
                <div
                  className="comp-main comp-heading2"
                  onClick={() => {
                    cGigsCount > 3 && history.push("/joblisting");
                  }}
                  style={{ cursor: cGigsCount < 3 && "default" }}
                >
                  {cGigsCount > 3 && "See all"}
                </div>
              </Col>
            </Row>
            {Dimensions.width > 768 && <div className="profileDivider3"></div>}
            {cGigs?.length > 0 ? (
              Dimensions.width < 768 ? (
                <Col xs={24} lg={7}>
                  <JobCard
                    {...(cGigs?.[0]||{})}
                    fromDashboard={true}
                    img={
                      cGigs[0]?.Regions?.Code != null &&
                      cGigs[0].Cities?.CityName != null
                        ? getImageByStateCode(
                            cGigs[0]?.Regions?.Code,
                            cGigs[0].Cities?.CityName
                          )
                        : candidate_img
                    }
                    RegionCode={cGigs[0]?.Regions?.Code}
                    CityName={cGigs[0].Cities?.CityName}
                    rates={cGigs[0]?.BudgetTypes?.BudgetTypeName}
                    budgetType={cGigs[0]?.BudgetTypes?.BudgetTypeCode}
                    budget={cGigs[0]?.BudgetMin}
                    facilityname={
                      professionCode === "IT" ? null : cGigs[0]?.FacilityName
                    }
                    title={cGigs[0]?.Title}
                    matchedbids={
                      cGigs[0]?.status[2]?.count
                        ? cGigs[0]?.status[2]?.count
                        : 0
                    }
                    cardFooter={true}
                    placedbids={
                      cGigs[0]?.status[0]?.count
                        ? cGigs[0]?.status[0]?.count
                        : 0
                    }
                    receivedbids={
                      cGigs[0]?.status[1]?.count
                        ? cGigs[0]?.status[1]?.count
                        : 0
                    }
                    professionCode={userProfile?.Professions?.ProfessionCode}
                    id={cGigs[0]?.JobOrderId}
                    JobOrderId={cGigs[0]?.JobOrderId}
                    created={cGigs[0].Created}
                    showAI={true}
                    
                  />
                </Col>
              ) : (
                <Row
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "35px",
                    // justifyContent: "space-between",
                    flexWrap: "wrap",
                    paddingLeft: Dimensions.width < 786 ? "15px" : "20px",
                  }}
                >
                  {cGigs?.length > 0 ? (
                    cGigs?.map((items, index) => {
                      return Dimensions.width < 786 && index > 1 ? null : items
                          ?.JobOrderStatuses?.JobOrderStatusName ==
                        "Draft" ? null : (
                        <Col className="jobCard-div-company" key={index}>
                          <JobCard
                            fromDashboard={true}
                            className="jobCard"
                            cardFooter={true}
                            id={items.JobOrderId}
                            {...items}
                            title={items.Title}
                            receivedbids={
                              items?.status[1]?.count
                                ? items?.status[1]?.count
                                : 0
                            }
                            placedbids={
                              items?.status[0]?.count
                                ? items?.status[0]?.count
                                : 0
                            }
                            budget={items.BudgetMin}
                            budgetType={items?.BudgetTypes?.BudgetTypeCode}
                            facilityname={items.FacilityName}
                            matchedbids={
                              items?.status[2]?.count
                                ? items?.status[2]?.count
                                : 0
                            }
                            created={items?.Created}
                            img={
                              // items.Location?.RegionCode !== null &&
                              // items.Location?.CityName !== null
                              //   ? getImageByStateCode(
                              //       items.Location?.RegionCode,
                              //       items.Location?.CityName
                              //     )

                              items?.Regions?.Code !== null &&
                              items?.Cities?.CityName !== null
                                ? getImageByStateCode(
                                    items?.Regions?.Code,
                                    items?.Cities?.CityName,
                                    items?.CompanyName
                                  )
                                : candidate_img
                            }
                            rates={items?.BudgetTypes?.BudgetTypeName}
                            RegionCode={items?.Regions?.Code}
                            CityName={items?.Cities?.CityName}
                            professionCode={
                              userProfile?.Professions?.ProfessionCode
                            }
                            showAI={true}
                          />
                        </Col>
                      );
                    })
                  ) : (
                    <Col xs={24}>
                      {" "}
                      <Empty />{" "}
                    </Col>
                  )}
                </Row>
              )
            ) : (
              <div className="button-container">
                <button
                  className={
                    Dimensions.width < 768
                      ? "uploadbtn postjobbtn"
                      : "uploaddesbtn"
                  }
                  onClick={() => history.push("/postjob")}
                >
                  {Dimensions.width < 768 ? `+ Add gigs` : `+`}
                </button>
                {Dimensions.width > 768 && (
                  <div className="add-heading">Add gigs</div>
                )}
              </div>
            )}
          </div>
          {Dimensions.width < 768 && <div className="profileDivider"></div>}
        </Col>
      </div>
    );
  } else {
    return (
      <div className="CpLoaderDiv">
        <Loader />
      </div>
    );
  }
}
